import { createMuiTheme } from '@material-ui/core/styles';
import { v4 as uuidv4 } from 'uuid';

export const themesArray = [
	{
		id: uuidv4(),
		type: 'light',
		name: 'white',
		background: {
			paper: '#fff'
		}
	},
	{
		id: uuidv4(),
		type: 'dark',
		name: 'black',
		background: {
			paper: '#272c34'
		}
	},
	{
		id: uuidv4(),
		type: 'dark',
		name: 'ocean',
		background: {
			paper: '#053f5e'
		}
	},
	{
		id: uuidv4(),
		type: 'dark',
		name: 'viola',
		background: {
			paper: '#45315c'
		}
	}
];

const pickPalette = (themes, themeName) => {
	return themes.filter(theme => theme.name === themeName)[0];
};

const theme = (themeType, themeName) =>
	createMuiTheme({
		palette: {
			...pickPalette(themesArray, themeName),
			primary: {
				light: '#33c9dc',
				main: '#00bcd4',
				dark: '#008394',
				contrastText: '#fff'
			},

			secondary: {
				light: '#ffcf33',
				main: '#ffc400',
				dark: '#b28900',
				contrastText: '#000000de'
			}
		},
		typography: {
			fontFamily: [
				'Poppins-Regular',
				'-apple-system',
				'BlinkMacSystemFont',
				'"Segoe UI"',
				'Roboto',
				'"Helvetica Neue"',
				'Arial',
				'sans-serif',
				'"Apple Color Emoji"',
				'"Segoe UI Emoji"',
				'"Segoe UI Symbol"'
			].join(',')
		}
	});

export default theme;
